import React from 'react';
import { Stack, Typography } from '@mui/material';

import { EMPTY_VALUE } from './lib';

interface Props {
  value: Record<string, any>;
}

// What each fees-and-taxes rules version changed for the quote (set by Apply/Reapply Taxes and Fees)
const VERSION_DESCRIPTIONS: Record<number, string> = {
  2: "Internal-only fees are left out of the customer's totals",
};

export const FeesAndTaxesCalcVersionChanges = ({ value }: Props) => {
  const before = value?.before ?? EMPTY_VALUE;
  const after = value?.after ?? EMPTY_VALUE;
  const description = VERSION_DESCRIPTIONS[value?.after];

  return (
    <Stack spacing={0.5}>
      <Typography variant="body2" fontWeight={500}>
        {`Fees and taxes rules updated: version ${before} → ${after}`}
      </Typography>

      {description && (
        <Typography variant="body2" color="text.secondary">
          {description}
        </Typography>
      )}
    </Stack>
  );
};
